import policies from './Policies.vue';

const PoliciesRoutes = {
  path: 'policies',
  name: 'config.policies',
  component: policies,
  meta: {
    prefix_permission: 'policies',
  },
};

export default PoliciesRoutes;
